import { Link } from "@tanstack/react-router";
import { MessageSquareText } from "lucide-react";

import { PessoaLabels } from "@/lib/labels";
import { cn } from "@/lib/utils";

const className = cn(
	"inline-flex size-6 shrink-0 items-center justify-center rounded-md text-whatsapp transition-colors",
	"hover:bg-whatsapp/10 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
);

export function ContactButton({ personId }: { personId: number | null }) {
	if (personId === null) {
		return null;
	}

	return (
		<Link
			data-slot="contact"
			to="/pessoa/$id"
			params={{ id: personId }}
			search={{ tab: "conversa" }}
			aria-label={PessoaLabels.contactButton}
			className={className}
		>
			<MessageSquareText className="size-4" />
		</Link>
	);
}
